import { Controller } from "@hotwired/stimulus"
import { debounce } from "../helpers/timing_helpers"
import { filterMatches } from "../helpers/text_helpers"

export default class extends Controller {
  static targets = [ "input", "item", "categorySelect", "tagSelect" ]

  initialize() {
    this.filter = debounce(this.filter.bind(this), 100)
  }

  filter() {
    const searchValue = this.inputTarget.value.trim()
    const categoryValue = this.hasCategorySelectTarget ? this.categorySelectTarget.value : ""
    const tagValue = this.hasTagSelectTarget ? this.tagSelectTarget.value : ""
    let visibleCount = 0

    this.itemTargets.forEach(item => {
      const matchesSearch = !searchValue || filterMatches(item.textContent, searchValue)
      const itemCategory = item.dataset.category || ""
      const matchesCategory = !categoryValue ||
        (categoryValue === "uncategorized" && !itemCategory) ||
        itemCategory === categoryValue
      const itemTags = (item.dataset.tags || "").split(",").filter(t => t)
      const matchesTag = !tagValue || itemTags.includes(tagValue)

      if (matchesSearch && matchesCategory && matchesTag) {
        item.removeAttribute("hidden")
        visibleCount++
      } else {
        item.toggleAttribute("hidden", true)
      }
    })

    // Hide date groups that have no visible items
    this.#hideEmptyDateGroups()

    // Show/hide no results message
    const hasActiveFilter = searchValue.length > 0 || categoryValue.length > 0 || tagValue.length > 0
    this.#toggleNoResultsMessage(visibleCount === 0 && hasActiveFilter)

    this.dispatch("changed")
  }

  #hideEmptyDateGroups() {
    // Find all date groups and check if they have visible items
    const dateGroups = this.element.querySelectorAll('.date-group')
    dateGroups.forEach(group => {
      const visibleItems = group.querySelectorAll('[data-filter-target="item"]:not([hidden])')
      if (visibleItems.length === 0) {
        group.style.display = 'none'
      } else {
        group.style.display = ''
      }
    })
  }

  #toggleNoResultsMessage(show) {
    let noResultsMsg = this.element.querySelector('[data-filter-no-results]')
    
    if (show) {
      if (!noResultsMsg) {
        noResultsMsg = document.createElement('div')
        noResultsMsg.setAttribute('data-filter-no-results', '')
        noResultsMsg.className = 'empty-state'
        noResultsMsg.innerHTML = `
          <div class="empty-icon">
            <i class="bi bi-search"></i>
          </div>
          <h3>No results found</h3>
          <p>Try adjusting your search terms</p>
        `
        const mainContent = this.element.querySelector('.page-main-content') || this.element.querySelector('.convos-main')
        if (mainContent) {
          const firstDateGroup = mainContent.querySelector('.date-group')
          if (firstDateGroup) {
            firstDateGroup.after(noResultsMsg)
          } else {
            mainContent.prepend(noResultsMsg)
          }
        }
      }
      noResultsMsg.style.display = ''
    } else if (noResultsMsg) {
      noResultsMsg.style.display = 'none'
    }
  }

  filterByCategory(event) {
    const category = event.currentTarget.dataset.category
    if (this.hasCategorySelectTarget) {
      this.categorySelectTarget.value = category
      this.filter()
    }
  }

  clearInput() {
    if (!this.hasInputTarget) return
    this.inputTarget.value = ""
  }
}
